module.exports = __webpack_public_path__ + "static/media/PTSansCaption-Bold.63841e83.ttf";